module.exports = __webpack_public_path__ + "0efb5427928ad2552a84ac887c8be973.svg";